import React from "react";
import Seo from "../components/Seo";

export default function RealisationsPage() {
  return (
    <main data-testid="realisations-page" className="bg-white">
      <Seo
        title="Projets de référence séchoir solaire | Thermasol Air Systems®"
        description="Nos projets de référence en séchage solaire par insufflation : séchoir solaire bois TERA Structures à Aléria (Corse), 584 panneaux PVT air Thermasol 550, éligible fiche CEE AGRI-EQ-110."
        canonical="https://thermasol-airsystems.fr/realisations/"
        ogImage="https://thermasol-airsystems.fr/images/seo/plan3d.webp"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Séchoirs solaires clé en main — projets de référence",
            serviceType: "Conception, fourniture et installation de séchoirs solaires par insufflation",
            provider: { "@type": "Organization", name: "Thermasol Air Systems" },
            areaServed: "Europe",
            description:
              "Projets de référence en séchage solaire : séchoir bois TERA Structures à Aléria (Corse), 584 panneaux PVT air Thermasol 550, éligible fiche CEE AGRI-EQ-110.",
          },
        ]}
      />

      <section className="pt-28 pb-10 bg-slate-900">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white leading-tight">
            Nos projets de référence en séchage solaire
          </h1>
          <p className="text-slate-300 mt-5">
            Chaque <a href="/sechoir-solaire" className="text-orange-400 font-semibold underline" data-testid="link-sechoir-solaire-realisations">séchoir solaire</a>{" "}
            Thermasol est dimensionné sur mesure par notre bureau d'études.
          </p>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-4 md:px-6 py-14">
        <article className="border border-slate-200 rounded-2xl shadow-lg overflow-hidden" data-testid="projet-tera">
          <div className="p-6 md:p-10">
            <div className="flex flex-wrap items-center gap-3">
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900">TERA Structures — Aléria (Corse) · Séchoir solaire bois</h2>
              <span className="bg-orange-100 text-orange-700 border border-orange-300 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">Projet en cours</span>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mt-8">
              <div className="md:col-span-2 space-y-4 text-slate-700 leading-relaxed">
                <p><strong>Client :</strong> TERA Structures · <strong>Secteur :</strong> bois / forestier · <strong>Lieu :</strong> Aléria (Haute-Corse, 20270).</p>
                <p>
                  Projet dimensionné : <strong>584 panneaux PVT air Thermasol 550</strong> sur toiture,{" "}
                  <strong>321 kWc électriques</strong>, ~950 MWh thermiques bruts/an soit <strong>~807 MWh utiles</strong> (ΔT 15 K),
                  environ <strong>1 630 kWh/an par panneau</strong>.
                </p>
                <p>
                  Système complet de séchage par insufflation : ventilateurs, chambre d'aspiration, chambre de
                  compression, gaines textiles.
                </p>
                <p><strong>Objectif :</strong> ~30 000 tonnes/an de bois séché.</p>
                <p>
                  Éligible <a href="/fiche-cee-agri-eq-110" className="text-orange-600 font-semibold underline" data-testid="link-cee-realisations">fiche CEE AGRI-EQ-110</a>{" "}
                  (produits forestiers, zone H3).
                </p>
              </div>
              <div className="space-y-4">
                <img src="/images/seo/plan3d.webp" alt="projet séchoir solaire bois TERA Structures Aléria Corse" loading="lazy" className="rounded-xl border border-slate-200 w-full" width="1264" height="848" />
                <img src="/images/seo/hero.webp" alt="projet séchoir solaire bois TERA Structures Aléria Corse" loading="lazy" className="rounded-xl border border-slate-200 w-full" width="1264" height="848" />
                <img src="/images/seo/panneau.webp" alt="projet séchoir solaire bois TERA Structures Aléria Corse" loading="lazy" className="rounded-xl border border-slate-200 w-full" width="1264" height="848" />
              </div>
            </div>

            <a href="/sechoir-solaire#etude" data-testid="cta-etude-realisations" className="inline-block mt-8 bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-4 rounded-full transition-colors">
              Votre projet est similaire ? Demandez votre étude gratuite
            </a>
          </div>
        </article>
      </div>
    </main>
  );
}
